<template>
    <a-modal
        :title="record ? `修改【${record.name}】的登录密码` : '修改用户登录密码'"
        :visible="visible"
        :centered="true"
        :confirm-loading="submitting"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="360"
        :maskClosable="false"
     >
        <a-form-model :model="form" :rules="rules" ref="_form">
            <a-form-model-item label="用户编号" prop="member_id">
                <a-input v-model="form.member_id" />
            </a-form-model-item>

            <a-form-model-item label="新密码" prop="password">
                <a-input v-model="form.password" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    export default {
        props: {
            visible: false,
            record: null,
            callback: null,
        },
        data() {
            return {
                password: undefined,
                submitting: false,
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    password: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: {
                    password: null,
                    member_id: null,
                },
            };
        },
        methods: {
            on_ok() {
                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post(`member/reset_password`, this.form)
                            .then((response) => {
                                if (response.success) {
                                    this.$emit("close");

                                    if (this.callback) {
                                        this.callback();
                                    }
                                    this.$message.success(response.message);
                                } else {
                                    this.$error({
                                        title: "修改失败",
                                        content: response.message,
                                    });
                                }
                            })
                            .catch(({ response }) => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                    }
                });
            },

            on_cancel() {
                this.$refs["_form"].resetFields();
                this.$emit("close");
            },
        },
    };
</script>
